<div class="content-wrapper" *ngIf="sid">
  <div class="sid-title">
    <h3 class="sid-title-title">SID Report: {{sid.title}}</h3>
    <h5 class="sid-title-extra">
      <span class="sid-title-status">Status: {{sid.status}}</span>
      <span class="sid-title-duedate">Due date: {{sid.dueDate | date:dateFormat}}</span>
    </h5>    
  </div>
</div>